export const logoLetter = [
  '35 26',
  `
  <path fill="currentColor" fill-rule="nonzero" d="M14.668 25.954l2.546-7.676 2.546 7.676h6.308L34.428.608H25.84l-2.926 8.854L19.988.608H14.44l-2.926 8.854L8.588.608H0l8.36 25.346h6.308zm-2.508-3.04h-.95L4.864 3.648H5.89l5.776 17.518 5.548-17.518 5.548 17.518 5.776-17.518h1.026l-6.346 19.266h-.95L17.214 6.992 12.16 22.914z" />
`,
];
